import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/g4158@2x.png")